import React from 'react';
import Select from '../../../../../components/input/Select';
import TableFilterInput from '../../../../../components/table/TableFilterInput';
import DateRangePicker from '../../../../../components/datePicker/DateRangePicker';
import CouponBenefit from '../../../common/CouponBenefit';
import CouponBenefitInfo from '../../../common/CouponBenefitInfo';
import CouponPeriod from '../../../common/CouponPeriod';
import Anchor from '../../../../../components/link/Anchor';
import {
  addAllItemToSelectList,
  openNewWindow,
  setColumnWidth,
  setDash,
  setDetailPageUrl,
} from '../../../../../lib/common';
import { setDateFormat } from '../../../../../lib/moment';
import { DATE_FORMAT } from '../../../../../constants/service/common/utilConstants';
import { COUPON_DETAIL_URL_PATH } from '../../../../../constants/service/common/urlConstants';
import {
  COUPON_AVAILABLE_TYPE_TEXT,
  COUPON_DISCOUNT_TYPE_SELECT_LIST,
} from '../../../../../constants/service/app/couponConstants';

/**
 *  쿠폰 리스트 컬럼
 */
const columns = (data) => {
  const { list, filterOption, toggleModal, onFilter } = data;

  return [
    {
      accessor: 'couponId',
      Header: '쿠폰 ID',
      resizable: true,
      filterable: true,
      fixed: 'left',
      width: 80,
      Cell: (row) => (
        <Anchor
          isUnderLine
          color="primary"
          text={row.value}
          onClick={() => openNewWindow(setDetailPageUrl(COUPON_DETAIL_URL_PATH, row.value))}
        />
      ),
      Filter: () => <TableFilterInput option={filterOption.couponId} onFilter={(couponId) => onFilter({ couponId })} />,
    },
    {
      accessor: 'couponName',
      Header: '쿠폰명',
      className: 'align-left',
      resizable: true,
      filterable: true,
      fixed: 'left',
      width: setColumnWidth(list, 'couponName'),
      Cell: (row) => (
        <Anchor
          isUnderLine
          color="primary"
          onClick={() =>
            toggleModal({
              name: 'couponDetailModal',
              value: true,
              data: {
                couponDetail: row.original,
              },
            })
          }
          text={`${row.original.couponName}`}
        />
      ),
      Filter: () => (
        <TableFilterInput option={filterOption.couponName} onFilter={(couponName) => onFilter({ name: couponName })} />
      ),
    },
    {
      accessor: 'description',
      Header: '쿠폰 설명',
      className: 'align-left',
      resizable: true,
      filterable: true,
      fixed: 'left',
      width: 200,
      Filter: () => (
        <TableFilterInput option={filterOption.description} onFilter={(description) => onFilter({ description })} />
      ),
    },
    {
      accessor: 'discountType',
      Header: '쿠폰 혜택',
      filterable: true,
      fixed: 'left',
      width: 120,
      Cell: (row) => <CouponBenefit type={row.value} amount={row.original.discountAmount} />,
      Filter: () => (
        <Select
          list={addAllItemToSelectList(COUPON_DISCOUNT_TYPE_SELECT_LIST)}
          onChange={(discountType) => onFilter({ discountType })}
          defaultValue={filterOption.discountType}
          value={filterOption.discountType}
          isTable={true}
          size="large"
        />
      ),
    },
    {
      accessor: 'exclude24k',
      Header: '24k 상품 제외 여부',
      width: 150,
      Cell: (row) => (row.value ? '24k 상품 제외' : '-'),
    },
    {
      accessor: 'code',
      Header: '코드',
      filterable: true,
      fixed: 'left',
      width: 100,
      Cell: (row) => setDash(row.value),
      Filter: () => <TableFilterInput option={filterOption.code} onFilter={(code) => onFilter({ code })} />,
    },
    {
      accessor: 'availableType',
      Header: '쿠폰 유형',
      width: 100,
      Cell: (row) => COUPON_AVAILABLE_TYPE_TEXT[row.value] || '_',
    },
    {
      Header: '쿠폰 혜택 정보',
      resizable: true,
      width: 160,
      Cell: (row) => (
        <CouponBenefitInfo
          type={row.original.discountType}
          amount={row.original.discountAmount}
          minimumPurchasePrice={row.original.minimumPurchasePrice}
          maxDiscountPrice={row.original.maxDiscountPrice}
        />
      ),
    },
    {
      accessor: 'createDate',
      Header: '생성일자',
      sortable: true,
      filterable: true,
      width: 320,
      Cell: (row) => setDateFormat(row.value, DATE_FORMAT.YMD_DASH_FORMAT),
      Filter: () => (
        <DateRangePicker
          value={filterOption.createDate}
          outFormat={DATE_FORMAT.YMD_DASH_FORMAT}
          onSelect={(data) => onFilter({ createDate: data })}
        />
      ),
    },
    {
      Header: '사용기간',
      width: 290,
      Cell: (row) => (
        <CouponPeriod
          type={row.original.periodType}
          startDate={row.original.startDate}
          endDate={row.original.endDate}
          dayPlus={row.original.dayPlus}
        />
      ),
    },
    {
      accessor: 'memo',
      Header: '메모',
      className: 'align-left',
      resizable: true,
      width: 200,
    },
  ];
};

export default columns;
